// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1nCxe","col":"styles_col__3s5RU"};